<template>
    <div class="bussiness_block my-0 py-4">
        <div class="card shadow border-0">
            <div class="row my-4 px-5 align-items-center justify-content-center">
                <div class="col-12">
                    <h1 class="card-title text-center">
                        Aktuální obchodní podmínky pro používání aplikace Salesman
                    </h1>
                </div>
                <div class="col-3">
                    <router-link class="btn btn_main" :to="{ name: 'BussinessTermsHistory' }">
                        {{ $t("termsAndConditions.history") }}
                    </router-link>
                </div>
            </div>
            <div class="card-body px-5">
                <BussinessTerms__1_0 />
            </div>
        </div>
    </div>
</template>

<script>
import BussinessTerms__1_0 from "@/components/BussinessTermsHistory/BussinessTerms__1_0.vue";
export default {
    components: {
        BussinessTerms__1_0
    }
};
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.bussiness_block {
    font-family: 'Arial', sans-serif;
    width: 95%;
    margin: 15px auto;
}

.card {
    border-radius: 35px;
    min-height: 100vh;
}

.list-group-item {
    border: 0;
    padding: 0.75rem 1.25rem;
}
</style>
